import * as React from "react"
const SvgStar = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m8.85 17.396 3.15-1.9 3.15 1.926-.825-3.6 2.775-2.4-3.65-.325-1.45-3.4-1.45 3.375-3.65.325 2.775 2.425zm3.15.45-4.15 2.5a.9.9 0 0 1-.575.15.97.97 0 0 1-.525-.2 1.2 1.2 0 0 1-.35-.437.87.87 0 0 1-.05-.588l1.1-4.725-3.675-3.175a.96.96 0 0 1-.275-1.075 1.1 1.1 0 0 1 .3-.45q.2-.174.55-.225l4.85-.425 1.875-4.45q.125-.3.388-.45.262-.15.537-.15t.537.15.388.45l1.875 4.45 4.85.425q.35.051.55.225t.3.45a.96.96 0 0 1-.275 1.075l-3.675 3.175 1.1 4.726a.87.87 0 0 1-.05.587q-.125.262-.35.438a.97.97 0 0 1-.525.2.9.9 0 0 1-.575-.15z" />
  </svg>
)
export default SvgStar
